function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9sb2dvdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTU0iLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2ljb25zL2xvZ291dC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSBcInByb3AtdHlwZXNcIjtcblxuZnVuY3Rpb24gTG9nb3V0KHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTE4IDEyVjhINy4wMjd2MTZIMTh2LTRcIlxuICAgICAgICBmaWxsPVwibm9uZVwiXG4gICAgICAgIHN0cm9rZT17cHJpbWFyeUNvbG9yfVxuICAgICAgICBzdHJva2VXaWR0aD1cIjJcIlxuICAgICAgICBzdHJva2VMaW5lY2FwPVwicm91bmRcIlxuICAgICAgICBzdHJva2VMaW5lam9pbj1cInJvdW5kXCJcbiAgICAgIC8+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTEyIDE3YTEgMSAwIDAxMC0yaDEwLjY5NmwtMS4yNTEtMS4yOTNhMS4wMjMgMS4wMjMgMCAwMTAtMS40MTQuOTQ1Ljk0NSAwIDAxMS4zNjggMGwyLjkwMyAzYTEuMDIzIDEuMDIzIDAgMDEwIDEuNDE0bC0yLjkwMyAzYS45NS45NSAwIDAxLS42ODQuMjkzLjk1Ljk1IDAgMDEtLjY4NC0uMjkzIDEuMDIzIDEuMDIzIDAgMDEwLTEuNDE0TDIyLjY5NSAxN0gxMnpcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5Mb2dvdXQucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBMb2dvdXQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function Logout(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M18 12V8H7.027v16H18v-4",
    fill: "none",
    stroke: primaryColor,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), ___EmotionJSX("path", {
    d: "M12 17a1 1 0 010-2h10.696l-1.251-1.293a1.023 1.023 0 010-1.414.945.945 0 011.368 0l2.903 3a1.023 1.023 0 010 1.414l-2.903 3a.95.95 0 01-.684.293.95.95 0 01-.684-.293 1.023 1.023 0 010-1.414L22.695 17H12z",
    fill: primaryColor
  }));
}

Logout.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default Logout;